import React, { useReducer } from 'react';
/* import {v4 as uuid} from "uuid"; */

import proyectoContext from './proyectoContext';
import proyectoReducer from './proyectoReducer';
import {
    FORMULARIO_PROYECTO,
    OBTENER_PROYECTOS,
    AGREGAR_PROYECTO,
    PROYECTO_ERROR,
    VALIDAR_FORMULARIO,
    PROYECTO_ACTUAL,
    ELIMINAR_PROYECTO} from '../../types';
import clienteAxios from '../../config/axios';

//Nota: todos los async se agregan despues de que se empiezan a obtener los datos del backend. 

const ProyectoState = props =>{
    //los sacamos porque ahora vienen de la base de datos
    /* const proyectos = [
        {id:1, nombre: 'Tienda Virtual'},
        {id:2, nombre: 'intranet'},
        {id:3, nombre: 'Diseño de Sitio web'},
        {id:4, nombre: 'MERN'}
    ] */

    const initialState = {
         proyectos : [],
        formulario : false,
        errorformulario: false,
        proyecto: null,
        mensaje:null
    }

    //Dispatch para ejecutar las acciones
    const [state, dispatch] = useReducer(proyectoReducer, initialState);
    
    //serie de funciones para el CRUD
    const mostrarFormulario = ()=>{
        dispatch({
            type: FORMULARIO_PROYECTO
        })
    }

    //obtener los proyectos
    const obtenerProyectos=async() /* proyectos */=>{
        
        try {
            const resultado= await clienteAxios.get('/api/proyectos');
        dispatch({
            type: OBTENER_PROYECTOS,
            /* payload: proyectos */
            payload: resultado.data.proyectos
        });

        } catch (error) {
            console.log(error)
            const alerta= {
                msg: 'hubo un error',
                categoria: 'alerta-Error'
            }
            dispatch({
                type:PROYECTO_ERROR,
                payload: alerta
            })
        }
    }

    //agregar un nuevo prouecto
    const agregarProyecto= async proyecto=>{
        /* proyecto.id = uuid(); */  //se quita una vez se tiene el backen listo

        try {
            const resultado= await clienteAxios.post('/api/proyectos',proyecto);
            /* console.log(resultado); */
            //insertar el proyecto en el state
            dispatch({
                type: AGREGAR_PROYECTO,
                //payload: proyecto cambiamos a la siguiente linea
                payload: resultado.data
        
        })

        } catch (error) {
            console.log(error)
            const alerta= {
                msg: 'hubo un error',
                categoria: 'alerta-Error'
            }
            dispatch({
                type:PROYECTO_ERROR,
                payload: alerta
            })
        }
    }

    //validar el formulario por errores

    const mostrarError= ()=>{
        dispatch({
            type: VALIDAR_FORMULARIO
        })
    }

    //seleccionar el proyecto que el usuario dio click
    const proyectoActual =proyectoID=>{
        dispatch({
            type: PROYECTO_ACTUAL,
            payload: proyectoID
        })
    }

    //eliminar el proyecto
    const eliminarProyecto = async proyectoID =>{
       try {

        await clienteAxios.delete(`/api/proyectos/${proyectoID}`)
            dispatch({
                type: ELIMINAR_PROYECTO,
                payload: proyectoID
        })
       } catch (error) {
           console.log(error)
           const alerta= {
               msg: 'hubo un error',
               categoria: 'alerta-Error'
           }
           dispatch({
               type:PROYECTO_ERROR,
               payload: alerta
           })
       }
    }

    return(
        <proyectoContext.Provider
            value={{
                proyectos: state.proyectos,
                formulario: state.formulario,
                errorformulario: state.errorformulario,
                proyecto: state.proyecto,
                mensaje: state.mensaje,
                mostrarFormulario,
                obtenerProyectos,
                agregarProyecto,
                mostrarError,
                proyectoActual,
                eliminarProyecto
            }}
        >
            {props.children}
        </proyectoContext.Provider>
    )
}

export default ProyectoState; 


